import Button from '@app/components/common/Button';
import Icon from '@app/components/common/Icon';
import Typography from '@app/components/common/Typography';
import { useTheme } from '@emotion/react';
import { adjustShade } from '@westondev/tableturn-core';
import { AnimatePresence, m } from 'framer-motion';

interface IStatusBar {
  isActive: boolean;
  title: string;
  onClick: () => void;
}
const StatusBar = ({ title, onClick, isActive }: IStatusBar) => {
  const theme = useTheme();
  return (
    <AnimatePresence>
      {isActive && (
        <m.div
          animate={{ opacity: 1, bottom: -53, transition: { duration: 0.4 } }}
          exit={{ opacity: 0, bottom: -30, transition: { duration: 0.3 } }}
          initial={{ opacity: 0, bottom: -30 }}
          whileHover={{
            backgroundColor: adjustShade(theme.colors.textBlue, -15),
          }}
          css={{
            position: 'absolute',
            bottom: '-53px',
            alignSelf: 'center',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '5px',
            paddingInline: '10px',
            borderRadius: '50px',
            backgroundColor: theme.colors.textBlue,
            height: '45px',
            zIndex: 1,
            boxShadow: theme.shadows[1],
            userSelect: 'none',
            cursor: 'pointer',
            hover: {
              backgroundColor: 'red',
            },
          }}
          onClick={onClick}>
          <Icon
            name="MdArrowForward"
            size="20px"
            color="white"
            csx={{ transform: 'rotate(-90deg)', marginBottom: '2px' }}
          />
          <Typography color="textWhite" fontWeight="medium">
            {title}
          </Typography>
          <Button
            variant="transparent"
            iconPosition="right"
            csx={{
              height: '30px',
              borderRadius: '50px',
              paddingInline: '10px',
              border: '1px solid white',
              '> span': {
                paddingLeft: '3px !important',
              },
            }}>
            <Typography color="textWhite">Refresh</Typography>
          </Button>
        </m.div>
      )}
    </AnimatePresence>
  );
};

export default StatusBar;
